<template>
  <div class="list_progress_none" v-if="list.content.length == 0">
    <p>
      요청하신 견적이 없습니다!<br />
      HOME 화면에서 나에게 맞는 상품을 찾아보세요!
    </p>
    <button @click="goLink('Mobile.Main')">HOME으로 가기</button>
  </div>
  <div class="list_progress_wrap" v-else>
    <Swiper
      :options="swiperOption"
      :pagination="true"
      @slideChange="changeSwiperIndex"
      ref="mySwiper"
    >
      <SwiperSlide>
        <div class="list_progress">
          <div class="progress_tab">
            <ul>
              <li
                :class="{ on: index == listSelectIndex }"
                v-for="(item, index) in list.content.slice(0, 2)"
                :key="index"
                @click="tabSelect(index)"
              >
                <button v-if="isStatus == 'END'">
                  {{ getCreateAt(item.requestedAt)
                  }}<span class="fini">모집마감</span>
                </button>
                <button v-else>
                  {{ getCreateAt(item.requestedAt)
                  }}<span>{{ getCreateAtDay(item.requestedAt) }} 후 마감</span>
                </button>
                <div class="bg_box"></div>
              </li>
            </ul>
          </div>
          <div
            class="progress_cont"
            :class="{ on: index == listSelectIndex }"
            v-for="(item, index) in list.content.slice(0, 2)"
            :key="index"
            @click="goView(item.id)"
          >
            <ul class="inter_prod_list prof_phone">
              <li class="phone_product">
                <div class="left">
                  <img :src="item.deviceImage" alt="" />
                </div>
                <div class="right">
                  <h4>{{ item.modelName }}</h4>
                  <p>{{ item.deviceColor }}</p>
                </div>
              </li>
              <li>
                <dl>
                  <dt>구매대상자</dt>
                  <dd v-if="item.areaName2">
                    {{ item.target == 1 ? '본인' : '부모님/자녀 등' }} -
                    {{ getAgeText(item.targetDetail) }}
                    ({{ item.areaName1 }}, {{ item.areaName2 }})
                  </dd>
                  <dd v-else>
                    {{ item.target == 1 ? '본인' : '부모님/자녀 등' }} -
                    {{ getAgeText(item.targetDetail) }}
                    ({{ item.areaName1 }})
                  </dd>
                </dl>
              </li>
              <li>
                <dl>
                  <dt>현재사용폰</dt>
                  <dd v-if="item.useDeviceName && item.target == 1">
                    {{ item.useTelecomName }} / {{ item.useDeviceName }}
                  </dd>
                  <dd v-else>
                    {{ item.useTelecomName }}
                  </dd>
                </dl>
              </li>
              <li>
                <dl>
                  <dt>변경통신사</dt>
                  <dd v-if="item.joinType == 'NEW'">
                    {{ item.telecomName }} (가입유형-신규)
                  </dd>
                  <dd v-else-if="item.joinType == 'CHANGE'">
                    {{ item.telecomName }} (가입유형-기기변경)
                  </dd>
                  <dd v-else-if="item.joinType == 'MNP'">
                    {{ item.telecomName }} (가입유형-번호이동)
                  </dd>
                </dl>
              </li>
              <!-- <li v-if="item.planName">
                <dl>
                  <dt>선호요금제</dt>
                  <dd>{{ item.planName }}</dd>
                </dl>
              </li> -->
            </ul>
            <div v-if="item.estimateStores && isType != 'view'">
              <div class="arrival" v-if="item.estimateStores.length > 0">
                <div class="prof_area">
                  <ul>
                    <li
                      v-for="(item_img, index_img) in item.estimateStores.slice(
                        0,
                        3,
                      )"
                      :key="index_img"
                    >
                      <div class="profile_image">
                        <div class="thumb_image">
                          <div class="thumb_image_inner">
                            <img
                              v-if="item_img.storeProfile"
                              :src="item_img.storeProfile"
                              alt=""
                            />
                            <img
                              v-else
                              :src="
                                setShopProfileImg(
                                  item_img.storeName,
                                  item_img.storeId,
                                )
                              "
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div class="profile_image">
                        <div class="thumb_image">
                          <div class="thumb_image_inner">
                            <img
                              :src="
                                require('@/assets/front/images/v2/profiles/img_prof_more.png')
                              "
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                    </li>
                    <!--4개까지는 매장 프로필 사진, 5개부터는 네번째 이미지는 이걸로-->
                  </ul>
                </div>
                <p>
                  총 {{ item.estimateStores.length }}개의 견적이 도착했어요!
                </p>
                <!--받은 견적 수-->
                <div class="num" v-if="item.unreadCnt > 0">
                  {{ item.unreadCnt }}
                </div>
                <!--확인 안 한 새로 받은 견적 수-->
              </div>
            </div>
          </div>
        </div>
      </SwiperSlide>
      <SwiperSlide v-if="list.content.length == 3">
        <div class="list_progress">
          <div class="progress_tab">
            <ul>
              <li
                class="on"
                v-for="(item, index) in list.content.slice(2, 3)"
                :key="index"
                @click="tabSelect(2)"
              >
                <button v-if="isStatus == 'END'">
                  {{ getCreateAt(item.requestedAt)
                  }}<span class="fini">모집마감</span>
                </button>
                <button v-else>
                  {{ getCreateAt(item.requestedAt)
                  }}<span>{{ getCreateAtDay(item.requestedAt) }} 후 마감</span>
                </button>
                <div class="bg_box"></div>
              </li>
            </ul>
          </div>
          <div
            class="progress_cont on"
            v-for="(item, index) in list.content.slice(2, 3)"
            :key="index"
            @click="goView(item.id)"
          >
            <ul class="inter_prod_list prof_phone">
              <li class="phone_product">
                <div class="left">
                  <img :src="item.deviceImage" alt="" />
                </div>
                <div class="right">
                  <h4>{{ item.modelName }}</h4>
                  <p>{{ item.deviceColor }}</p>
                </div>
              </li>
              <li>
                <dl>
                  <dt>구매대상자</dt>
                  <dd v-if="item.areaName2">
                    {{ item.target == 1 ? '본인' : '부모님/자녀 등' }} -
                    {{ getAgeText(item.targetDetail) }}
                    ({{ item.areaName1 }}, {{ item.areaName2 }})
                  </dd>
                  <dd v-else>
                    {{ item.target == 1 ? '본인' : '부모님/자녀 등' }} -
                    {{ getAgeText(item.targetDetail) }}
                    ({{ item.areaName1 }})
                  </dd>
                </dl>
              </li>
              <li>
                <dl>
                  <dt>현재사용폰</dt>
                  <dd v-if="item.useDeviceName && item.target == 1">
                    {{ item.useTelecomName }} / {{ item.useDeviceName }}
                  </dd>
                  <dd v-else>
                    {{ item.useTelecomName }}
                  </dd>
                </dl>
              </li>
              <li>
                <dl>
                  <dt>변경통신사</dt>
                  <dd v-if="item.joinType == 'NEW'">
                    {{ item.telecomName }} (가입유형-신규)
                  </dd>
                  <dd v-else-if="item.joinType == 'CHANGE'">
                    {{ item.telecomName }} (가입유형-기기변경)
                  </dd>
                  <dd v-else-if="item.joinType == 'MNP'">
                    {{ item.telecomName }} (가입유형-번호이동)
                  </dd>
                </dl>
              </li>
              <!-- <li v-if="item.planName">
                <dl>
                  <dt>선호요금제</dt>
                  <dd>{{ item.planName }}</dd>
                </dl>
              </li> -->
            </ul>
            <div v-if="item.estimateStores && isType != 'view'">
              <div class="arrival" v-if="item.estimateStores.length > 0">
                <div class="prof_area">
                  <ul>
                    <li
                      v-for="(item_img, index_img) in item.estimateStores.slice(
                        0,
                        3,
                      )"
                      :key="index_img"
                    >
                      <div class="profile_image">
                        <div class="thumb_image">
                          <div class="thumb_image_inner">
                            <img
                              v-if="item_img.storeProfile"
                              :src="item_img.storeProfile"
                              alt=""
                            />
                            <img
                              v-else
                              :src="
                                setShopProfileImg(
                                  item_img.storeName,
                                  item_img.storeId,
                                )
                              "
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div class="profile_image">
                        <div class="thumb_image">
                          <div class="thumb_image_inner">
                            <img
                              :src="
                                require('@/assets/front/images/v2/profiles/img_prof_more.png')
                              "
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                    </li>
                    <!--4개까지는 매장 프로필 사진, 5개부터는 네번째 이미지는 이걸로-->
                  </ul>
                </div>
                <p>
                  총 {{ item.estimateStores.length }}개의 견적이 도착했어요!
                </p>
                <!--받은 견적 수-->
                <div class="num" v-if="item.unreadCnt > 0">
                  {{ item.unreadCnt }}
                </div>
                <!--확인 안 한 새로 받은 견적 수-->
              </div>
            </div>
          </div>
        </div>
      </SwiperSlide>
    </Swiper>
    <div class="swiper-pagination"></div>
    <!-- <ul class="list_progress_pager">
      <li class="on"></li>
    </ul> -->
  </div>
</template>
<script>
import * as util from '@common/lib/common/utils.js';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';

import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
// Import Swiper styles
import 'swiper/swiper.scss';

export default {
  props: {
    list: Object,
    isStatus: String,
    isType: String,
    isSelectIndex: Number,
    isSlideIndex: {
      type: Number,
      default: 0,
    },
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  data(props) {
    return {
      listSelectIndex: props.isSelectIndex || 0,
      listSlideIndex: props.isSlideIndex || 0,
      swiperOption: {
        // loop: true,
        // autoplay: {
        //   delay: 3000,
        // },
        watchOverflow: true, // dot가 하나일때는 안보이게 처리
        spaceBetween: 20,
        speed: 300,
        observer: true,
        observeParents: true,
        autoHeight: true,
        pagination: {
          el: '.swiper-pagination',
        },
        // speed: 2500,
      },
      isUpdated: false,
    };
  },
  mounted() {
    // alert(this.listSlideIndex);
  },
  async created() {
    this.$nextTick(() => {
      if (this.isType == 'view') {
        this.$refs.mySwiper.$swiper.slideTo(this.listSlideIndex);
      }
    });
  },
  // updated() {
  //   console.log('updated');
  //   alert(this.listSlideIndex);
  //   // this.toSlide();
  //   if (!this.isUpdated) {
  //     this.$refs.mySwiper.$swiper.slideTo(this.listSlideIndex, 100, false);
  //     this.isUpdated = true;
  //   }
  // },
  computed: {},
  methods: {
    getCreateAt(createAt) {
      return format(parseISO(createAt), 'yy.MM.dd');
    },
    getCreateAtDay(createAt) {
      const createdAt = new Date(createAt);

      const endDay = format(
        new Date(createdAt.setDate(createdAt.getDate() + 7)),
        'yyyy-MM-dd HH:mm:ss',
      );

      const now = new Date();
      new Date(now.setDate(now.getDate()), 'yyyy-MM-dd HH:mm:ss');

      var resdays = this.getDateDiff(now, endDay);

      // console.log('박수 : ' + resdays);
      return resdays;
    },
    goLink(link) {
      this.$router.push({ name: link });
    },
    getDateDiff(d1, d2) {
      const date1 = new Date(d1);
      const date2 = new Date(d2);

      const diffDate = date1.getTime() - date2.getTime();

      let mathVal = Math.abs(diffDate / (1000 * 60 * 60 * 24));

      // 시간으로 표시
      if (mathVal < 1) {
        return (
          Math.ceil(Math.abs(diffDate / (1000 * 60 * 60))).toString() + '시간'
        ); // 밀리세컨 * 초 * 분 * 시 = 일
      } else {
        return (
          Math.ceil(Math.abs(diffDate / (1000 * 60 * 60 * 24))).toString() +
          '일'
        ); // 밀리세컨 * 초 * 분 * 시 = 일
      }
    },
    isItemCompose(item) {
      let itemCompose = '';

      if (item.itemInternet) {
        itemCompose = '[인터넷] ';
        itemCompose += item.itemInternet;
      }

      if (item.itemTv) {
        itemCompose += '<br/>';
        itemCompose += '[TV] ';
        itemCompose += item.itemTv;
      }

      return itemCompose;
    },
    tabSelect(index) {
      this.listSelectIndex = index;

      this.$emit(
        'setSlideIndex',
        this.$refs.mySwiper.$swiper.activeIndex,
        this.list.content[this.listSelectIndex].id,
        this.listSelectIndex,
      );
    },
    setShopProfileImg(shopName, shopId) {
      let path = util.setShopProfile(shopName, shopId, '120x120', '25');

      return path;
    },
    getAgeText(age) {
      if (age == 'U_12') {
        return '키즈';
      } else if (age == 'O_65') {
        return '어르신';
      } else if (age == 'O_19') {
        return '성인';
      } else if (age == 'B_35_64') {
        return '일반';
      } else if (age == 'B_19_34') {
        return '청년';
      } else if (age == 'U_18' || age == 'B_12_18') {
        return '청소년';
      }
    },
    goView(id) {
      this.$emit('goView', id, 'ING');
    },
    changeSwiperIndex() {
      // alert(this.$refs.mySwiper.$swiper.activeIndex);

      // this.$refs.mySwiper.$swiper.slideTo(
      //   this.$refs.mySwiper.$swiper.activeIndex,
      // );
      // if (this.$refs.mySwiper.$swiper.activeIndex == 0) {
      //   // this.isTab = 'tab_2';
      // } else {
      //   // this.isTab = 'tab_1';
      // }

      if (this.$refs.mySwiper.$swiper.activeIndex == 1) {
        this.listSelectIndex = 2;
      } else {
        this.listSelectIndex = 0;
      }

      this.$emit(
        'setSlideIndex',
        this.$refs.mySwiper.$swiper.activeIndex,
        this.list.content[this.listSelectIndex].id,
        this.listSelectIndex,
      );
    },
  },
};
</script>
